import axios from '../assets/axios'

export default {
  namespaced: true,

  state: {
    statusCode: '',
    outlineInfo: {
      sysOrderLine: [], // 各个系统订单汇总
      sysHasOverdueOrder: false, // 存在逾期订单
      sysTotalAmount: 0.0, // 系统应还金额
      sysCompleted: false // 全系统已经结清
    }, 

    tmdOrderList: [], // tmd 订单列表

    // 平台账单详情
    platOrder: {
      onGoinSum: 0, // 进行中的订单数量
      totalAmount: 0, // 应该总金额
      type: '', // 平台
      hasOverdueOrder: false, // 是否存在逾期
      hasCompleted: false, // 已全部结清
      orderList: [] // 所有订单
    }
  },

  mutations: {
    getOrderOutline (state, { data, code }) {
      if (data) {
        Object.keys(data).forEach(key => {
          state.outlineInfo[key] = data[key]
        })
      }
      state.statusCode = code
    }, 

    systemMaintain (state) {
      state.statusCode = '999999'
    },

    setPlatOrder (state, data = {}) { 
      state.platOrder.onGoinSum = data.onGoinSum || 0
      state.platOrder.totalAmount = data.totalAmount || 0
      state.platOrder.type = data.type || 'YZD'
      state.platOrder.hasOverdueOrder = data.hasOverdueOrder || false
      state.platOrder.hasCompleted = data.hasCompleted || false
      state.platOrder.orderList = data.orderOutLineInfo || []
    },

    setTMDOrderList (state, data) {
      state.tmdOrderList = data
    }
  },

  actions: {
    // 获取平台账单详情
    async getOrderListX ({ commit }, params) {
      const response = await axios.post('/order/v1/list', params)
      if (response.data.success === true) {
        const sysOrderLine = response.data.data.sysOrderLine
        if (sysOrderLine) {
          commit('setPlatOrder', sysOrderLine[0])
        }
        if (sysOrderLine) {
          commit('setTMDOrderList', sysOrderLine)
        }
      }
      return response.data
    },

    async getOrderHisX (store, params) {
      const response = await axios.get('/order/v1/history-list', { params })
      return response.data
    },

    // 获取订单概要，首页
    async getOrderOutlineX ({ commit }, params) {
      try {
        const response = await axios.get('/order/v1/outline', { params })
        commit('getOrderOutline', response.data)
        return response.data
      } catch (exp) {
        commit('systemMaintain', true)
      }
    },
        
    // 获取订单详情
    async getOrderDetailX ({ commit }, params) {
      const response = await axios.post('/order/v1/detail', params)
      return response.data
    },
        
    // 获取签章协议列表
    async getOrderSignListX ({ commit }, params) {
      const response = await axios.post('/order/v1/query-sign-info', params)
      return response.data
    },

    // 获取协议模版
    async getOrderAgreementX ({ commit }, params) {
      const response = await axios.post('/order/agreement', params)
      return response.data
    },
    // 获取平台枚举
    async getPlatformX (store, params) {
      const response = await axios.get('/index/v1/allPlatform', params)
      return response.data
    },
    // 获取消费账单列表
    async queryExpenseListX (store, params) {
      const response = await axios.post('/order/v1/consumptionBills', params)
      return response.data
    },
    // 获取消费账单详情
    async queryExpenseDetailX (store, params) {
      const response = await axios.post('/order/v1/consumptionBillDetail', params)
      return response.data
    }
  }
}